module.exports = __webpack_public_path__ + "static/media/ic_check_no_border.13d8d5d9.svg";